import { render, staticRenderFns } from "./monitorCounters.vue?vue&type=template&id=3507b3e3&"
import script from "./monitorCounters.vue?vue&type=script&lang=js&"
export * from "./monitorCounters.vue?vue&type=script&lang=js&"
import style0 from "./monitorCounters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports